<template>
  <div class="thumbsMain">
    <div class="thumbsMain--content">
      <div class="thumbsMain--title">
        <h4 class="thumbTitle">
          {{ title }}
        </h4>
      </div>
      <div class="thumbsMain--text">
        <span class="thumbText">
            <span class="thumbText--ico"></span>
            {{ text }}
        </span>
      </div>
    </div>
    <div class="thumbsMain--image">
      <ImgThumb :img='img'/>
    </div>
  </div>
</template>

<script>
import ImgThumb from '@/components/_ImgThumb'

export default {
  name: 'ThumbsMain',
  components: {
    ImgThumb
  },
  props: {
    title: {
      type: String,
      default: 'ThumbsMain title'
    },
    text: {
      type: String,
      default: 'ThumbsMain text'
    },
    alt: {
      type: String,
      default: 'Observatório Internacional de Capacidades Humanas, Desenvolvimento e Políticas Públicas'
    },
    img: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    }
  }
}
</script>

<style>

</style>
